Array.prototype.superJoin = function(seperator, start, length) {
    var result = "";
    for(var i = start; i < this.length-1 && i < start+length-1; i++)
        result += this[i] + seperator;
    result += this[i];
    return result;
}

Array.prototype.lastElement = function() {
    return this[this.length-1];
}

String.prototype.superSplit = function(seperator) {
    var split = this.split(seperator);
    for(var i=0; i<split.length; i++) {
        if(split[i] == "")
            split.splice(i--, 1);
    }

    var resultArray = [];
    var max = Math.min(4, split.length);
    for(var wordCount = max; wordCount > 1; wordCount--) {
        resultArray[max-wordCount] = [];
        for(var startIndex = 0; startIndex <= split.length - wordCount; startIndex++) {
            resultArray[max-wordCount][startIndex] = split.superJoin(" ", startIndex, wordCount);
        }
    }
    resultArray[max-1] = split;
    return resultArray;
}

String.prototype.superIndexOf = function(stringValue) {
    var index = -1;
    var indexes = [];

    if(stringValue == "")
        return indexes;
    do {
        index = this.indexOf(stringValue, index + 1);
        if(index != -1)
            indexes.push(index);
    } while(index != -1);
    return indexes;
}

String.prototype.insert = function (index, string) {
  if (index > 0)
    return this.substring(0, index) + string + this.substring(index, this.length);
  else
    return string + this;
};